(() => {
  'use strict';

  /* ========================================================================
     VoidReveal - IntersectionObserver for .void-reveal elements
     ======================================================================== */

  let revealObserver = null;

  const initReveal = (scope) => {
    const root = scope || document;
    const elements = root.querySelectorAll('.void-reveal:not(.is-visible)');

    if (!elements.length) return;

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          }
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -50px 0px',
        }
      );
    }

    for (const el of elements) {
      revealObserver.observe(el);
    }
  };

  /* ========================================================================
     VoidParallax - scroll-based transforms for [data-void-parallax]
     ======================================================================== */

  const parallaxElements = [];
  const trackedElements = new Set();
  let parallaxTicking = false;

  const collectParallaxElements = (scope) => {
    const root = scope || document;
    const nodes = root.querySelectorAll('[data-void-parallax]');

    for (const el of nodes) {
      if (trackedElements.has(el)) continue;
      trackedElements.add(el);
      parallaxElements.push({
        el,
        speed: parseFloat(el.getAttribute('data-void-parallax')) || 0.1,
      });
    }
  };

  const updateParallax = () => {
    const viewportHeight = window.innerHeight;

    for (const item of parallaxElements) {
      const rect = item.el.getBoundingClientRect();
      const elementCenter = rect.top + rect.height * 0.5;
      const viewportCenter = viewportHeight * 0.5;
      const offset = (elementCenter - viewportCenter) * item.speed;

      item.el.style.transform = `translateY(${offset}px)`;
    }

    parallaxTicking = false;
  };

  const onScroll = () => {
    if (!parallaxElements.length) return;
    if (!parallaxTicking) {
      parallaxTicking = true;
      requestAnimationFrame(updateParallax);
    }
  };

  /* ========================================================================
     Initialization
     ======================================================================== */

  const init = (scope) => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    initReveal(scope);

    if (!reducedMotion) {
      collectParallaxElements(scope);
    }
  };

  const onReady = () => {
    init();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
